module.exports = __webpack_public_path__ + "static/biennale-book-f0e3c3a9ca7d86a24c747661d497a129.otf";